import type { InfoCardProps } from "@components/InfoCardProps.js";
import type { Tenant } from "@core/schema/Tenant.js";

export function getWhenRescueProject(tenant: Tenant): InfoCardProps[] {
	return [
		{
			title: "Máte pozastavený, nebo zpožděný projekt",
		},
		{
			title: "Jste nespokojeni se současným dodavatelem",
		},
		{
			title: "Během projektu se vyskytly technické potíže",
		},
		{
			title: "Potřebujete přejít na nové technologie",
		},
	];
}
